import { Component, h, WriteOnlyRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { HorizontalCapsuleContainerMenu } from "./HorizontalCapsuleContainer";
import { ProfileCapsuleButton } from "./Button";
import { UserState } from "../../defs/userState";
import { ProfileCircle } from "./ProfileCircle";
import { useFrontendCore, useFrontendServices } from "@kosmod/core";
import { createAuthenticateModal } from "../Authenticate";
import { Account, AccountDescription } from "../../defs";
import { AuthState } from "../../hooks";

export * from './ProfileCircle';

export type ProfileCapsuleMenuProps = {
  auth: AuthState,
  account: AccountDescription | null,
  profileCircleRef?: WriteOnlyRef<HTMLElement>,
}

export const ProfileCapsuleMenu: Component<ProfileCapsuleMenuProps> = ({ account, profileCircleRef, auth }) => {
  const { modal, site } = useFrontendServices();

  if (!account)
    return h(html.button, { onClick(event) {
      modal.add(createAuthenticateModal('sign-up', auth))
    },}, "Create an Account")

  return h(HorizontalCapsuleContainerMenu, { elements: [
    h(ProfileCircle, { name: account.username, colorHash: account.id, profileCircleRef }),
    h(ProfileCapsuleButton, { icon: 'settingsCog' }),
    h(ProfileCapsuleButton, { icon: 'house', onClick() { site.navigate({ path: '/games' }) } }),
  ] })
};